import AScene from '../../library/ExtendedObjects/AScene.js';
import Starfield from './Preloader_Starfield.js';
import Sun from './Preloader_Sun.js';
import Preloader_Rockets from './Preloader_Rockets.js';
import gameData from '../../gameData.js';
import Utils from '../../library/Utils.js';
import InputHelper from '../../library/InputHelper.js';

export default class Preloader extends AScene
{
    preload() 
    {
        this.assetsLoaded = false;
        this.fontsLoaded = false;
        this.loadFonts();
        this.addAssets();

        /**
         * LOAD THE STUFF
         */
        
        this.loadAtlas(this.defaultAtlas, 'assets/images');
        this.loadAtlas("pigMasks", 'assets/images');
        this.loadAudioSprite(this.defaultAudioSprite, 'assets/sounds');

        Object.keys(gameData.animations).forEach((key)=>{ this.loadAtlas(key, 'assets/images'); });
    }

    loadFonts()
    {
        let fontKeys = Object.keys(gameData.fonts);
        let fonts = [];
        for(let i = 0; i < fontKeys.length; i++)
        {
            let fontName = gameData.fonts[fontKeys[i]];
            fonts.push(fontName);
        }
        WebFont.load({
            active: ()=>{this.fontLoadingComplete();},
            custom: {
              families: fonts,
              urls: ['assets/fonts/stylesheet.css'],
            },
        });
    }

    loadImage(key, location)
    {
        this.load.image(key, location + '/' + key + ".png", location);
    }

    loadAtlas(key, location)
    {
        this.load.multiatlas(key, location + '/' + key + '.json', location);
    }

    loadBitmapFont(key, location)
    {
        this.load.bitmapFont(key, location + '/' + key + '.png', location + '/' + key + '.fnt');
    }

    loadJson(key, location)
    {
        this.load.json(key, location + '/' + key + '.json');
    }

    loadAudioSprite(key, location)
    {
        this.load.audioSprite(key, location + '/' + key + '.json', [
            location + '/' + key + '.ogg',
            location + '/' + key + '.mp3',
            location + '/' + key + '.m4a',
            location + '/' + key + '.ac3'
        ]);
    }

    addAssets()
    {
        this.background = this.addRect(0, 0, this.size.width, this.size.height, 0x071e26);
        this.starfield = this.addContainer(0, 0, new Starfield(this));
        this.sun = this.addContainer(this.mid.x, this.mid.y + 70, new Sun(this, ()=>{this.eh_PlayButton_Clicked();}));
        this.logo = this.add.image(this.mid.x, 0, 'preloader', 'Preloader_Logo.png');
        this.rockets = this.addContainer(this.mid.x, this.mid.y + 70, new Preloader_Rockets(this));

        this.logo.setScale(0);
        this.addTween(this.logo, 500, {scaleY: 1, scaleX: 1, alpha: 1, y: this.size.height * .5 - 250, delay: 500}, Phaser.Math.Easing.Back.Out);

        this.load.on('fileprogress', ()=>{this.progressMade();});
        this.load.on('complete', ()=>{this.assetLoadingComplete();});
    }

    progressMade()
    {
        this.sun.setProgress(this.load.progress);
    }

    fontLoadingComplete()
    {
        this.fontsLoaded = true;
    }

    assetLoadingComplete()
    {
        this.assetsLoaded = true;
    }

    loadingComplete()
    {
        this.loadAnimations();

        this.sun.enablePlayButton();
        // if(gameData.startScene == "")
        // {
        //     this.scene.start('Intro');
        // }
        // else this.scene.start(gameData.startScene);

    }

    loadAnimations()
    {
        let anims = gameData.animations;
        let animKeys = Object.keys(anims);

        for(let i = 0; i < animKeys.length; i++)
        {
            let key = animKeys[i];
            let anim = anims[key];
            let frames = this.anims.generateFrameNames(key, {start: anim.start, end: anim.end, prefix: key + "_" });
            this.anims.create({ key: key, frames: frames, frameRate: anim.frameRate, repeat: anim.repeats ? -1 : 0});
        }
    }

    update()
    {
        if(this.assetsLoaded && this.fontsLoaded)
        {
            this.assetsLoaded = this.fontsLoaded = false;
            this.loadingComplete();
        }
    }

    eh_PlayButton_Clicked()
    {
        //console.log("Telling it to start: " + gameData.startScene);
        this.scene.start(gameData.startScene); 
    }
}